import { useEffect, useMemo, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Bounce, toast } from "react-toastify";
import api from "../api";

const EditFeedback = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);
  const { codiceFiscale } = location.state || {};

  const fetchFeedback = async () => {
    setLoading(true);
    try {
      const res = await api.get(`/feedback/${codiceFiscale}`);
      if (res.status === 200) {
        const data = Array.isArray(res.data)
          ? res.data
          : res.data
            ? [res.data]
            : [];
        if (data.length === 0) {
          toast.info("Nessun feedback trovato per questo docente.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
          });
          navigate("/feedback");
          return;
        }
        setFeedbacks(data);
      } else {
        toast.error("Feedback non trovato", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        navigate("/feedback");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
      navigate("/feedback");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!codiceFiscale) {
      toast.error("ID feedback mancante");
      navigate("/feedback");
      return;
    }
    fetchFeedback();
  }, [codiceFiscale]);

  const trainer = useMemo(() => feedbacks[0]?.trainer ?? null, [feedbacks]);
  const primaryFeedback = useMemo(
    () => feedbacks[0] ?? null,
    [feedbacks]
  );

  if (loading && feedbacks.length === 0) {
    return (
      <div className="overlay">
        <div className="spinner"></div>
      </div>
    );
  }

  if (!loading && feedbacks.length === 0) {
    return (
      <div className="content-page">
        <div className="page-header">
          <div className="page-title">Dettaglio Feedback #{id}</div>
          <div className="controls">
            <button className="back-btn" onClick={() => navigate("/feedback")}>
              ← Torna ai Feedback
            </button>
          </div>
        </div>
        <div className="page-content edit-feedback">
          <div className="details-card">
            <div className="card-content">
              <p>Nessun feedback disponibile.</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  function formatDateTime(dateString) {
    if (!dateString) return "";

    const date = new Date(dateString);
    if (isNaN(date)) return "";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}.${month}.${year}`;
  }

  return (
    <div className="content-page">
      <div className="page-header">
        <div className="page-title">Dettaglio Feedback #{id}</div>
        <div className="controls">
          <button className="back-btn" onClick={() => navigate("/feedback")}>
            ← Torna ai Feedback
          </button>
        </div>
      </div>
      <div className="page-content edit-feedback">
        <div className="details-card">
          <div className="card-content">
            <div className="info-sections">
              <div className="info-section">
                <div className="section-header">
                  <i className="fa-solid fa-info-circle"></i>
                  Informazioni Generali
                </div>
                <div className="info-grid">
                  <div className="info-item">
                    <label className="info-label">ID Feedback:</label>
                    <span className="info-value">
                      {primaryFeedback?.idFeedback ?? "-"}
                    </span>
                  </div>
                  <div className="info-item">
                    <label className="info-label">Docente ID:</label>
                    <span className="info-value">
                      {trainer?.id ?? "-"}
                    </span>
                  </div>
                  <div className="info-item">
                    <label className="info-label">Feedback totali:</label>
                    <span className="info-value">{feedbacks.length}</span>
                  </div>
                </div>
              </div>

              <div className="info-section">
                <div className="section-header">
                  <i className="fa-solid fa-search"></i>
                  Dati docente
                </div>
                <div className="info-grid">
                  <div className="info-item">
                    <label className="info-label">Nome:</label>
                    <span className="info-value">
                      {trainer?.nome || "-"}
                    </span>
                  </div>
                  <div className="info-item">
                    <label className="info-label">Cognome:</label>
                    <span className="info-value">
                      {trainer?.cognome || "-"}
                    </span>
                  </div>
                  <div className="info-item">
                    <label className="info-label">Email:</label>
                    <span className="info-value">
                      {trainer?.email || "-"}
                    </span>
                  </div>
                  <div className="info-item">
                    <label className="info-label">Codice Fiscale:</label>
                    <span className="info-value">
                      {trainer?.codiceFiscale || "-"}
                    </span>
                  </div>
                  <div className="info-item">
                    <label className="info-label">Cellulare:</label>
                    <span className="info-value">
                      {trainer?.cellulare || "-"}
                    </span>
                  </div>
                  <div className="info-item">
                    <label className="info-label">Città Di Residenza:</label>
                    <span className="info-value">
                      {trainer?.cittàDiResidenza || "-"}
                    </span>
                  </div>
                  <div className="info-item">
                    <label className="info-label">Sesso:</label>
                    <span className="info-value">
                      {trainer?.sesso || "-"}
                    </span>
                  </div>
                  <div className="info-item">
                    <label className="info-label">Stato Occupazionale:</label>
                    <span className="info-value">
                      {trainer?.statoOccupazionale || "-"}
                    </span>
                  </div>
                  <div className="info-item">
                    <label className="info-label">Livello Inglese:</label>
                    <span className="info-value">
                      {trainer?.livelloInglese || "-"}
                    </span>
                  </div>
                  <div className="info-item">
                    <label className="info-label">Livello Informatica:</label>
                    <span className="info-value">
                      {trainer?.livelloInformatica || "-"}
                    </span>
                  </div>
                </div>
              </div>

              <div className="info-section">
                <div className="section-header">
                  <i className="fa-solid fa-user-tie"></i>
                  Dati Feedback
                </div>
                <div className="feedback-list">
                  {feedbacks.map((feedbackItem, index) => (
                    <div className="feedback-entry" key={feedbackItem.idFeedback ?? index}>
                      <div className="feedback-entry-header">
                        <span className="label">
                          Feedback #{feedbackItem.idFeedback ?? index + 1}
                        </span>
                        <span className="label-secondary">
                          Inserito il {formatDateTime(feedbackItem.dataInserimento) || "-"}
                        </span>
                      </div>
                      <div className="info-grid">
                        <div className="info-item">
                          <label className="info-label">
                            Feedback Coinvolgimento:
                          </label>
                          <span className="info-value">
                            {feedbackItem.feedbackCoinvolgimento ?? "-"}
                          </span>
                        </div>
                        <div className="info-item">
                          <label className="info-label">
                            Feedback Partecipanti:
                          </label>
                          <span className="info-value">
                            {feedbackItem.feedbackPartecipanti ?? "-"}
                          </span>
                        </div>
                        <div className="info-item">
                          <label className="info-label">Feedback Tutor:</label>
                          <span className="info-value">
                            {feedbackItem.feedbackTutor ?? "-"}
                          </span>
                        </div>
                        <div className="info-item">
                          <label className="info-label">Feedback Efficacia:</label>
                          <span className="info-value">
                            {feedbackItem.feedbackEfficacia ?? "-"}
                          </span>
                        </div>
                        <div className="info-item">
                          <label className="info-label">Note Aggiuntive:</label>
                          <span className="info-value">
                            {feedbackItem.noteAggiuntive || "-"}
                          </span>
                        </div>
                        <div className="info-item">
                          <label className="info-label">Punteggio Totale:</label>
                          <span className="info-value">
                            {feedbackItem.punteggioTotale ?? "-"}
                          </span>
                        </div>
                        <div className="info-item">
                          <label className="info-label">Autore:</label>
                          <span className="info-value">
                            {feedbackItem.autore || "-"}
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditFeedback;
